import { RouteConfig } from "vue-router";

export const RCandidateProfile: RouteConfig = {
  path: "profile/:sponsorship_candidate_id(\\d+)",
  name: "CandidateProfile",
  component: () =>
    import(
      /* webpackChunkName: "candidates-details" */
      "./VCandidateProfile.vue"
    ),
  meta: {
    title: "Candidate`s details",
    label: "candidates detail",
    tabName: "candidates",
    alias: "candidates",
  },
};
